export default {
  GENERAL: 'general',
  LANGUAGE: 'language',
  PUSH_NOTIFICATIONS: 'push-notifications',
  BIOMETRIC: 'biometric-access',
  MODIFY_PASSWORD: 'modify-mls-password',
  APP_VERSION: 'app-version',
  SAP_ASSOCIATE: 'sap-associate',
};
